import React from 'react'
import { CardBody as RSCardBody, CardHeader as RSCardHeader } from 'reactstrap'

export const CardBody = (props) => {
  const { style, className } = props
  return (
    <RSCardBody style={style} className={className}>
      {props.children}
    </RSCardBody>
  )
}

export const CardHeader = (props) => {
  const { style, className } = props
  return (
    <RSCardHeader style={style} className={className}>
      {props.children}
    </RSCardHeader>
  )
}
